import SingleLineText from './ui/SingleLineText';
import React from 'react';
import { Box } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function MenuRow({ icon, tileBg, iconColor, label, statusText, statusColor, badgeText, onClick, isLast }) {
    return (
        <Box
            onClick={onClick}
            role="button"
            tabIndex={0}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 16px',
                cursor: 'pointer',
                borderBottom: isLast ? 'none' : '1px solid #f0f0f0',
                transition: 'opacity 0.15s ease, transform 0.15s ease',
                '&:active': { opacity: 0.7, transform: 'scale(0.99)' },
            }}
        >
            <Box sx={{
                width: 48, height: 48, borderRadius: '14px', flexShrink: 0,
                bgcolor: tileBg,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
                {React.cloneElement(icon, { sx: { fontSize: 24, color: iconColor } })}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <SingleLineText sx={{
                    fontSize: 16, fontWeight: 700, letterSpacing: '-0.02em',
                    color: '#1a1a1a', lineHeight: 1.3,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                    {label}
                </SingleLineText>
                {statusText && (
                    <SingleLineText sx={{
                        fontSize: 13,
                        fontWeight: statusColor ? 700 : 500,
                        letterSpacing: '-0.01em',
                        color: statusColor || '#777',
                        lineHeight: 1.45,
                        mt: '2px',
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                        {statusText}
                    </SingleLineText>
                )}
            </Box>
            {badgeText && (
                <Box sx={{
                    px: '8px',
                    height: 24,
                    minWidth: 24,
                    borderRadius: 999,
                    bgcolor: '#ef4444',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 800,
                    lineHeight: 1,
                    flexShrink: 0,
                    boxShadow: '0 0 0 4px rgba(239,68,68,0.12)',
                    animation: 'reviewBadgeShake 2s ease-in-out infinite',
                    '@keyframes reviewBadgeShake': {
                        '0%, 72%, 100%': { transform: 'translateX(0) rotate(0deg)', boxShadow: '0 0 0 4px rgba(239,68,68,0.12)' },
                        '76%': { transform: 'translateX(-2px) rotate(-7deg)' },
                        '80%': { transform: 'translateX(2px) rotate(7deg)', boxShadow: '0 0 0 7px rgba(239,68,68,0.08)' },
                        '84%': { transform: 'translateX(-1px) rotate(-4deg)' },
                        '88%': { transform: 'translateX(1px) rotate(4deg)' },
                        '92%': { transform: 'translateX(0) rotate(0deg)', boxShadow: '0 0 0 4px rgba(239,68,68,0.12)' },
                    },
                }}>
                    {badgeText}
                </Box>
            )}
            <ChevronRightIcon sx={{ fontSize: 18, color: '#bbb', opacity: 0.7, flexShrink: 0 }} />
        </Box>
    );
}

export default function HomeMenuList({ items }) {
    if (!items || items.length === 0) return null;

    return (
        <Box sx={{
            mx: 2, mt: 2,
            bgcolor: '#fff',
            borderRadius: '16px',
            border: '1px solid #f0f0f0',
            overflow: 'hidden',
        }}>
            {items.map((item, i) => (
                <MenuRow
                    key={item.label}
                    {...item}
                    isLast={i === items.length - 1}
                />
            ))}
        </Box>
    );
}
